import { userConstants } from '../_constants';
import { userService } from '../_services';
import { history } from '../_helpers';
import { registerEffect } from '../_effects';

export const registerActions = {
  register,
};

function register(user) {
  return (dispatch) => {
    dispatch(request(user));
    registerEffect.registerSet(user).then(
      (user) => {
        dispatch(success(user));
        localStorage.setItem('user', JSON.stringify(user.data?.response));
        localStorage.setItem('CustomerCode', JSON.stringify(user.data?.customerCode));
        localStorage.setItem('iskycenabled', JSON.stringify(user.data?.isKYCEnabled));
        if (user.data.statusCode == '404') {
          history.push('/add-customer');
        } else if (user.data.statusCode == '201') {
          history.push('/mpin');
        } else if (user.data.statusCode == '200' && user.data.response.isPasswordReq == 'Y') {
          history.push('/set-credentials');
        } else if (user.data.statusCode == '200' && user.data.response.isPasswordReq == 'N') {
          history.push('/reset-pin');
        } else if (user.data.statusCode == '405') {
          history.push('/verify-otp');
        } else if (user.data.statusCode == '401') {
          history.push('/');
        } else {
          history.push('/');
        }
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(user) {
    return { type: userConstants.REGISTER_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.REGISTER_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.REGISTER_FAILURE, error };
  }
}

// import ActionUtility from '../../utilities/ActionUtility';

// export const registerActions = {
//     register,
//   requestError
// }
//    const REQUEST_SHOW = 'ShowsAction.REQUEST_SHOW';
//    const REQUEST_SHOW_FINISHED = 'ShowsAction.REQUEST_SHOW_FINISHED';

//    const REQUEST_EPISODES = 'ShowsAction.REQUEST_EPISODES';
//    const REQUEST_EPISODES_FINISHED = 'ShowsAction.REQUEST_EPISODES_FINISHED';

//    const REQUEST_CAST = 'ShowsAction.REQUEST_CAST';
//    const REQUEST_CAST_FINISHED = 'ShowsAction.REQUEST_CAST_FINISHED';

//    const REQUEST_ERROR = 'ShowsAction.REQUEST_ERROR';
//    const REQUEST_ERROR_FINISHED = 'ShowsAction.REQUEST_ERROR_FINISHED';

//    function register() {
//     return async (dispatch, getState) => {
//         console.log(getState());
//       const showId = getState().regMobile;

//       await ActionUtility.createThunkEffect(dispatch, registerActions.REQUEST_SHOW, registerEffect.registerSet, showId);
//     };
//   }

//    function requestError() {
//     return async (dispatch, getState) => {
//       await ActionUtility.createThunkEffect(dispatch, registerActions.REQUEST_ERROR, registerEffect.requestError);
//     };
//   }
